import { apiClient } from './client';

export type BotUpdateType =
  | 'MESSAGE'
  | 'EDITED_MESSAGE'
  | 'DELETED_MESSAGE'
  | 'CALLBACK_QUERY'
  | 'MEMBERSHIP';

export interface BotCommand {
  command: string;
  description: string;
}

export interface PublicBot {
  id: string;
  ownerId: string;
  userId: string;
  username: string;
  displayName: string;
  avatarUrl: string | null;
  description: string | null;
  isEnabled: boolean;
  allowedUpdateTypes: BotUpdateType[];
  commands: BotCommand[];
  webhookUrl: string | null;
  webhookLastOkAt: string | null;
  webhookLastErrorAt: string | null;
  webhookLastError: string | null;
  lastUsedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface BotInlineButton {
  text: string;
  callbackData?: string;
  url?: string;
}
export type BotInlineKeyboard = BotInlineButton[][];

export const botsApi = {
  async list(): Promise<PublicBot[]> {
    const r = await apiClient.get<PublicBot[]>('/api/bots');
    return r.data;
  },
  async create(input: { username: string; displayName: string; description?: string }) {
    const r = await apiClient.post<{ bot: PublicBot; token: string }>('/api/bots', input);
    return r.data;
  },
  async get(botId: string): Promise<PublicBot> {
    const r = await apiClient.get<PublicBot>(`/api/bots/${botId}`);
    return r.data;
  },
  async update(
    botId: string,
    input: {
      displayName?: string;
      description?: string | null;
      isEnabled?: boolean;
      allowedUpdateTypes?: BotUpdateType[];
    },
  ): Promise<PublicBot> {
    const r = await apiClient.patch<PublicBot>(`/api/bots/${botId}`, input);
    return r.data;
  },
  async rotateToken(botId: string): Promise<{ token: string; bot: PublicBot }> {
    const r = await apiClient.post<{ token: string; bot: PublicBot }>(`/api/bots/${botId}/rotate-token`);
    return r.data;
  },
  async remove(botId: string): Promise<void> {
    await apiClient.delete(`/api/bots/${botId}`);
  },
  async startBot(botId: string): Promise<{ ok: true; botUserId: string }> {
    const r = await apiClient.post<{ ok: true; botUserId: string }>(`/api/bots/${botId}/start`);
    return r.data;
  },
  async sendCallback(input: { messageId?: string; dmId?: string; data: string }): Promise<{ callbackQueryId: string }> {
    const r = await apiClient.post<{ callbackQueryId: string }>(`/api/bots/callback`, input);
    return r.data;
  },
};
